import ppUtilities from '../ppUtilities.js';
import * as _ from 'lodash-es';
import Cookies from 'js-cookie';
import { isVatActive, isVatUndefined } from '../../../utils/ecommerce/vat.js';
import { toNumberCurrency } from '../../../utils/ecommerce/currency.js';
class PPdata {
	constructor(rawPPData, ctID, componentId) {
		this.response = rawPPData;
		this.currency = {
			currencyCode: `${this.response.currency}`,
			currencyPlacement: this.response.currencyPlacement ? `${this.response.currencyPlacement}` : 'before',
			currencySymbol: `${this.response.currencySymbol}`,
		};
		this.cartInfo = this.createCartModel();
		this.ctId = ctID; // comparison table id
		this.componentId = componentId;
		this.utils = new ppUtilities();
		this.isVatActive = !isVatUndefined() && isVatActive();
		this.pathIdLookUp = {};
		this.createDataModel = this.createDataModel.bind(this);
		this.createCartModel = this.createCartModel.bind(this);
	}

	getPPModel() {
		if (_.isEmpty(this.response.data)) {
			return {
				error: 'No product data available, check selected content fragment',
			};
		}
		let prodData = this.response.data.filter((prod) => !_.isEmpty(prod)); // Remove empty product obj
		prodData.forEach((item, indx) => {
			// test if item is directory (vs prod obj)
			let folderName = Object.keys(item)[0];
			let isDirectory = item[folderName];

			// if directory has prod obj
			if (isDirectory && Array.isArray(isDirectory)) {
				let directoryNotEmpty = isDirectory[0].filter((prod) => !_.isEmpty(prod));
				if (directoryNotEmpty.length) {
					prodData[indx] = this.createDataModel(directoryNotEmpty, this.response?.config);
				}
			}
		});
		let ppNormalized = {};
		try {
			ppNormalized = this.createDataModel(prodData, this.response?.config);
			this.setPathIdLookUp(ppNormalized, this.response?.config);
			return ppNormalized;
		} catch (e) {
			ppNormalized.error = 'error' + e;
		}
		return ppNormalized;
	}

	createDataModel(response, config) {
		let productData = response.map((product, indx) => {
			if (Array.isArray(product)) {
				return product;
			}

			let hasProducts = [];
			const keys = Object.keys(product).sort();
			// i.e. product1, product2, product3, ...
			const productKeys = keys.filter((key) => key.match(/^product\d{1,2}$/));
			productKeys.forEach((key) => {
				if (typeof product[key] == 'string' && product[key].length) {
					const productObj = this.parseProductString(product[key]);
					hasProducts.push(this.nomrmalizeProductKeys(productObj));
				} else if (typeof product[key] == 'object') {
					const productObj = { ...product[key], ...(product[key + 'Icon'] && { productIcon: product[key + 'Icon'] }) };
					hasProducts.push(this.nomrmalizeProductKeys(productObj));
				}
			});
			// product represents the card and products is the renewal terms, they have their own sku
			// TODO: eventually will rename product to card.
			product.products = hasProducts
				.filter((prod) => {
					if (_.isEmpty(prod)) {
						console.error('no product issue!', prod);
						return false;
					}

					return !!prod.productSku || !!prod.noPriceLabel || prod.isFree?.toString() === 'true';
				})
				.map((prod) => {
					if (!prod.isFree) {
						prod.isFree = false;
					}
					if (window.storeVariables?.geoblockingStatus === 'enabled') {
						prod.isPurchasable = 'false';
					}

					let productSku = prod.productSku;
					if (prod.isPurchasable == 'true') {
						if (!prod.amount) {
							console.error('ERROR: Purchasable product with no price', prod);
							return;
						}

						// We will use vat pricing if VAT is active (.vatAmount)
						let amount = this.isVatActive && prod.vatAmount ? prod.vatAmount : prod.amount;
						let priceObj = (() => {
							return {
								amount: toNumberCurrency(amount),
								// 'symbol': amount.match(/\D/gm)[0]
							};
						})();

						let formattedPrice = this.utils.formatStorePrice(priceObj.amount, this.response.formattedLocale, this.currency);

						return {
							isPurchasable: true,
							amount: priceObj.amount,
							__amount__: toNumberCurrency(prod.amount),
							__vatAmount__: toNumberCurrency(prod.vatAmount),
							displayPrice: formattedPrice,
							productTitle: prod.productTitle,
							renewalTitle: prod.renewalTermProduct || null,
							tag: prod.productLicense,
							modalIdentifier: prod.modalIdentifierDropdown || null,
							currency: prod.currency,
							_id: prod._id,
							qty: !isNaN(prod.productQuantity) ? Number(prod.productQuantity) : null,
							qtyFrom: Number(prod.qtyFrom),
							qtyTo: Number(prod.qtyTo),
							sku: productSku,
							...(prod.productIcon && { productIcon: prod.productIcon }),
							// This dataLayerSku is for analytics.
							dataLayerSku: productSku,
							moreInfo: prod.addMoreInfo || null,
							// there are products that have price and purchasable true but they are not handle but cart
							noPriceLabel: prod.noPriceLabelProduct || null,
							noPriceLink: prod.noPriceLinkProduct || null,
						};
					} else {
						return {
							isPurchasable: false,
							isFree: prod.isFree,
							productTitle: prod.productTitle,
							tag: prod.productLicense,
							modalIdentifier: prod.modalIdentifierDropdown || null,
							_id: prod._id || ppUtilities.create_UUID(),
							sku: productSku || ppUtilities.create_UUID(),
							...(prod.productIcon && { productIcon: prod.productIcon }),
							// This dataLayerSku is for analytics.
							dataLayerSku: productSku,
							moreInfo: prod.addMoreInfo || null,
							noPriceLabel: prod.noPriceLabelProduct || null,
							noPriceLink: prod.noPriceLinkProduct || null,
						};
					}
				});
			// products are not comming as an array from api;
			let productModel = {};
			const title = product.productTitle || product.bundleTitle;
			const tag = product.productTag || product.bundleTag;
			const longDescription = product.longDescription || product.bundleLongDescription;
			const bullet1 = product.shortDescriptionBullet1 || product.bundleShortDescriptionBullet1;
			const bullet2 = product.shortDescriptionBullet2 || product.bundleShortDescriptionBullet2;
			const bullet3 = product.shortDescriptionBullet3 || product.bundleShortDescriptionBullet3;
			const systemRequirementUrl = product.systemRequirementUrl || product.bundleSystemRequirementsLink;
			const systemRequirementLabel = product.bundleSystemRequirementsLabel;
			const languageSupportedUrl = product.languageSupportedUrl || product.bundleSupportedLanguagesLink;
			const languageSupportedLabel = product.bundleSupportedLanguagesLabel;

			productModel.componentId = this.componentId;
			productModel.id = ppUtilities.create_UUID();
			productModel.title = title;
			productModel.tag = tag;
			productModel.modalIdentifier = product.modalIdentifierDropdown || null;
			productModel.termMoreInfo = product.termMoreInfo || null;
			productModel.systemRequirementUrl = systemRequirementUrl;
			productModel.systemRequirementLabel = systemRequirementLabel;
			productModel.languageSupportedUrl = languageSupportedUrl;
			productModel.languageSupportedLabel = languageSupportedLabel;
			productModel.whatsIncluded = product.whatsIncluded;
			productModel.longDescription = longDescription;
			productModel.bullets = [bullet1, bullet2, bullet3];
			productModel.products = product.products;
			productModel.allRenewalTitle = product.renewalTerm;
			if (productModel.products.length) {
				productModel.allSkus = {};
				let hasActiveProduct = false;
				product.products.forEach((prod) => {
					if (!prod) {
						return;
					}

					productModel.allSkus[prod.sku] = productModel.id;
				});
				if (product.products[0].isPurchasable) {
					productModel.activeSku = product.products[0].sku;
					productModel.activePrice = product.products[0].amount;
					productModel.activeTag = product.products[0].tag;
				} else {
					product.products.forEach((prod) => {
						if (!hasActiveProduct && prod.isPurchasable) {
							hasActiveProduct = true;
							productModel.activeSku = prod.sku;
							productModel.activePrice = prod.amount;
							productModel.activeTag = prod.tag;
						}
					});
					if (!hasActiveProduct) {
						productModel.activeSku = product.products[0].sku;
						productModel.activePrice = product.products[0].amount;
						productModel.activeTag = product.products[0].tag;
					}
				}
			}

			productModel.compare = false;

			productModel.productPath = product.path.replace(/(\/jcr:content\/data\/master)/, '');
			productModel.icon = product.productIcon;
			productModel.ctID = this.ctId;
			productModel.inputError = { error: false };
			productModel.qty = 1;
			productModel.cartQty = { qty: 0, update: false };

			const isBundle = config?.isBundleByPath?.[productModel.productPath];
			if (isBundle) {
				// convert object to array
				productModel = productModel.products.map((product) => {
					const qty = product.qty || 1;
					return {
						...productModel,
						id: ppUtilities.create_UUID(),
						icon: product.productIcon,
						activeSku: product.sku,
						activePrice: product.amount * qty,
						activeTag: product.tag,
						products: [
							{
								...product,
								renewalTitle: productModel.allRenewalTitle,
							},
						],
						qty: qty,
					};
				});
			}

			return productModel;
		});
		return productData;
	}

	createCartModel() {
		let currLocale = document.documentElement.lang; // As per Husain instruction 08/07/19
		// Prospect Id
		let prospectIdObj = JSON.parse(localStorage.getItem('prosId'));

		currLocale = currLocale.indexOf('-') > -1 ? currLocale : this.response.locale;
		let cartModel = {};
		cartModel.locale = currLocale;
		cartModel.zone = this.response.zone;
		cartModel.currency = this.response.currency;
		cartModel.distributorNumber = this.response.distributorNumber;
		cartModel.istApiUrl = this.response.istApiUrl || 'https://istapistg.esri.com';
		cartModel.metadata = {};
		cartModel.metadata.formattedLocale = this.response.formattedLocale;
		cartModel.metadata.currency = this.currency;
		cartModel.metadata.isOmni = this.response.isOmni == 'true' ? true : false;
		cartModel.metadata.storeDomain = this.response.storeDomain;
		cartModel.metadata.sfReferenceId = Cookies.get('sf_id') || Cookies.get('epn_id') || '';
		cartModel.metadata.customerProspectId = (_.isObject(prospectIdObj) && prospectIdObj.value) || '';

		return cartModel;
	}

	getProductResponse() {
		return this.response;
	}

	getECartResponse() {
		return this.cartInfo;
	}

	parseProductString(prodString) {
		const parsedProd = {};
		if (prodString) {
			prodString = prodString.replace(/[{}]/g, '');
			const prodArr = prodString.split(', ');
			prodArr.forEach((prod) => {
				const property = prod.split('=');
				const key = property[0];
				const value = property.slice(1).join('=');
				parsedProd[key] = value;
			});
		}
		return parsedProd;
	}

	setPathIdLookUp(response, config) {
		//comparison data unique identifier is the content fragment path
		// need to normalize it by id

		// if product is a bundle, we only need to get the first product in the array
		const resp = response.map((prod) => {
			const isBundle = Array.isArray(prod) && config?.isBundleByPath?.[prod[0].productPath];
			return isBundle ? prod[0] : prod;
		});
		const products = _.flatten(resp);
		let lookUp = {};
		let pathArr = [];
		products.forEach((prod) => {
			lookUp[prod.productPath] = prod.id;
			pathArr = [...pathArr, prod.productPath];
		});
		lookUp = { ...lookUp, pathArr };
		this.pathIdLookUp = lookUp;
	}

	getPathIdLookUp() {
		return this.pathIdLookUp;
	}

	nomrmalizeProductKeys(productObj) {
		const product = { ...productObj };
		for (const key in product) {
			// i.e. product1Title, product1Sku, product1License, noPriceLinkProduct1, noPriceLabelProduct1, ...
			const productRegex = /(w*)(p|P)roduct\d{1,2}(w*)/g;
			if (key.match(productRegex)) {
				// remove digit from key
				const newKey = key.replace(productRegex, '$1$2roduct$3');
				product[newKey] = product[key];
				delete product[key];
			}

			const moreInfoRegex = /addMoreInfo\d{1,2}/g;
			if (key.match(moreInfoRegex)) {
				const newKey = key.replace(moreInfoRegex, 'addMoreInfo');
				product[newKey] = product[key];
				delete product[key];
			}
		}

		return product;
	}
}

export default PPdata;
